<template>
  <carousel
    v-if="showCarousel"
    selector=".carousel-wrapper"
    variant="dashboard"
    :key="'carousel-' + filteredCards.length"
  >
    <section class="carousel dashboard-carousel component standard">
      <div class="carousel-wrapper show1">
        <dashboard-card
          v-for="(card, i) in filteredCards"
          v-bind:key="'card-' + i + filteredCards.length"
          :card="card"
          :card-index="i"
          @dismissClicked="handleDismissClick($event)"
        />
      </div>
    </section>
  </carousel>
</template>
<script>
import DashboardCard from "./components/dashboard-card.vue";
import { mapActions, mapGetters, mapState } from "vuex"

export default {
  name: "dashboard-carousel",
  components: {
    DashboardCard,
  },
  data() {
    return {
      filteredCards: [],
      showCarousel: true
    };
  },
  props: {
    cards: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['haveProfileData']),
  },
  watch: {
    filteredCards(val) {
      if(val.length === 0) {
        document.querySelector(".dashboard-links").classList.add("no-border-top");
        document.querySelector(".dashboard-links").classList.add("border-left");
        this.showCarousel = false
      }
    }
  },
  async mounted() {
    await this.initUser()
    this.$nextTick(() => {
      this.filterCards()
      if (this.filteredCards.length > 0) {
        document.querySelector(".dashboard-links").classList.remove("no-border-top");
        document.querySelector(".dashboard-links").classList.remove("border-left");
      }
    })
  },
  methods: {
    ...mapActions('auth', ['getProfile']),
    async initUser() {
      if (this.user && !this.haveProfileData) {
        await this.getProfile()
      }
    },
    filterCards() {
      const hideSensitiveDataTerms = this.user.sensitiveDataAccepted || !!localStorage.getItem("hideSensitiveDataTerms");
      const hideMarketingOpt = this.user.newsletter || !!localStorage.getItem("hideMarketingOpt");

      this.filteredCards = this.cards.filter((currentCard) => {
        return !(currentCard.isSensitiveDataTerms && hideSensitiveDataTerms)
        && !(currentCard.isMarketingOptIn && hideMarketingOpt);
      });
    },
    handleDismissClick(event) {
      if (event.card.isSensitiveDataTerms) {
        localStorage.setItem("hideSensitiveDataTerms", true);
        this.filteredCards.splice(event.cardIndex, 1)
      } else if (event.card.isMarketingOptIn) {
        localStorage.setItem("hideMarketingOpt", true);
        this.filteredCards.splice(event.cardIndex, 1)
      }
    },
  },
};
</script>
